<template>
  <div>
    <div class="ObjectStorageDetail-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountTypeName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.bucketName }}</BreadcrumbItem>
        <BreadcrumbItem to="/monitor/objectStorageMonitor">{{
          $t("alarms.objectStorage.objectStorage")
        }}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <Row type="flex" justify="space-between" class="code-row-bg">
      <Col span="6">
        <Card style="height: 480px">
          <Row>
            <Row style="height: 240px">
              <Col
                span="24"
                style="
                  text-align: center;
                  font-size: 103px;
                  display: block;
                  margin-top: 8px;
                "
              >
                <Icon type="ios-briefcase" />
              </Col>
              <Col style="text-align: center; font-size: 18px">{{
                this.$route.query.bucketName
              }}</Col>
            </Row>
            <Row>
              <Col style="margin-bottom: 8px">{{
                $t("alarms.objectStorage.objectStorageConfiguration")
              }}</Col>
              <Row>
                <Col span="6">{{ $t("alarms.elasticResource.type") }}:</Col>
                <Col span="18">{{ this.$route.query.accountTypeName }}</Col>
              </Row>
            </Row>
          </Row>
        </Card>
      </Col>
      <Col span="13">
        <Card style="height: 480px">
          <ul class="content">
            <li>
              <Row>
                <Col span="12">
                  <Col span="4">
                    <Button shape="circle" icon="ios-laptop"></Button>
                  </Col>
                  <Col span="20">
                    <Row>
                      <Col>{{
                        $t("alarms.objectStorage.configurationInformation")
                      }}</Col>
                      <Row class="host">
                        <Col>
                          <ul>
                            <li>
                              {{ $t("alarms.objectStorage.bucketName") }}:
                            </li>
                            <li>{{ bucketName }}</li>
                          </ul>
                        </Col>
                        <Col>
                          <ul>
                            <li>{{ $t("alarms.common.createdTime") }}:</li>
                            <li>{{ creationDate }}</li>
                          </ul>
                        </Col>
                      </Row>
                    </Row>
                  </Col>
                </Col>
                <Col span="12">
                  <Col span="4">
                    <Button shape="circle" icon="ios-pulse"></Button>
                  </Col>
                  <Col span="20">
                    <Row>
                      <Col>{{ $t("alarms.common.monitorMessage") }}</Col>
                      <Row class="host">
                        <Col>
                          <ul>
                            <li>{{ $t("alarms.common.monitorItems") }}：</li>
                            <li>
                              {{ monitoringNum }}{{ $t("alarms.common.count") }}
                            </li>
                          </ul>
                        </Col>
                        <Col v-show="this.$route.query.accountTypeName != 'Tencent Cloud'">
                          <a @click="monitorMQ">{{
                            $t("alarms.common.viewMonitoringOverview")
                          }}</a>
                        </Col>
                      </Row>
                    </Row>
                  </Col>
                </Col>
              </Row>
            </li>
            <li>
              <Row>
                <Col span="12">
                  <Col span="4">
                    <Button shape="circle" icon="ios-medkit-outline"></Button>
                  </Col>
                  <Col span="20">
                    <Row>
                      <Col>{{ $t("alarms.common.alertRule") }}</Col>
                      <Row class="host">
                        <Col>
                          <ul>
                            <li>{{ $t("alarms.common.alertRule") }}：</li>
                            <li>0</li>
                          </ul>
                        </Col>
                        <Col>
                          <ul>
                            <li>{{ $t("alarms.common.untreated") }}：</li>
                            <li>0</li>
                          </ul>
                        </Col>
                        <Col>
                          <a class="disableHref">{{
                            $t("alarms.common.viewAlarmRules")
                          }}</a>
                        </Col>
                      </Row>
                    </Row>
                  </Col>
                </Col>
              </Row>
            </li>
          </ul>
        </Card>
      </Col>
      <Col span="4">
        <Card style="height: 480px">
          <Row>
            <Row style="margin-bottom: 10px">
              <Col>{{ $t('alarms.common.tags') }}</Col>
            </Row>
            <Row>
              <Col v-for="(item, index) in tagList" v-bind:key="index">
                <Tag color="default">{{ item.key }} : {{ item.value }}</Tag>
              </Col>
            </Row>
          </Row>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import utils from "../../../utils/utils.js";
export default {
  name: "ObjectStorageDetail",
  data() {
    return {
      id: "",
      accountId: "",
      bucketName: "",
      region: "",
      tagList: [],
      extranetEndpoint: "",
      intranetEndpoint: "",
      location: "",
      creationDate: "",
      accountTypeName: "",
      accountName: "",
      monitoringNum: ""
    };
  },
  mounted() {
    this.queryBucketByName();
  },
  methods: {
    // 通过brokerId查询实例
    queryBucketByName: function() {
      this.$api.bucket
        .queryBucketByName({
          accountId: this.$route.query.accountId,
          bucketName: this.$route.query.bucketName,
          region: this.$route.query.region
        })
        .then(res => {
          this.extranetEndpoint = res.data.extranetEndpoint;
          this.intranetEndpoint = res.data.intranetEndpoint;
          this.location = res.data.location;
          this.bucketName = res.data.bucketName;
          this.monitoringNum = res.data.monitoringNum;
          this.creationDate = utils.methods.formatDate(res.data.creationDate);
        });
    },
    // 点击查看监控概览
    monitorMQ: function() {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.bucketName = this.$route.query.bucketName;
      this.region = this.$route.query.region;
      this.accountName = this.$route.query.accountName;
      this.accountTypeName = this.$route.query.accountTypeName;
      this.$router.push({
        path: "/monitor/objectStorage/",
        query: {
          id: this.id,
          accountId: this.accountId,
          bucketName: this.bucketName,
          region: this.region,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName
        }
      });
    }
  }
};
</script>

<style scoped>
.ObjectStorageDetail-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
.host ul {
  list-style: none;
  overflow: hidden;
}
.host ul li {
  float: left;
}
.content > li {
  margin-bottom: 6px;
  border-bottom: 1px dashed #ccc;
  padding: 12px;
}
.content > li:last-child {
  border: none;
}
.disableHref {
  cursor: default;
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/object_storage/ObjectStorageDetail.vue